module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"他のレビューを書く","expected_reward":"最大 {0} 付与可能"}}')
  delete Component.options._Ctor
}
